import { render } from "./cartCard.vue?vue&type=template&id=0809f848&scoped=true"
import script from "./cartCard.vue?vue&type=script&lang=js"
export * from "./cartCard.vue?vue&type=script&lang=js"

import "./cartCard.vue?vue&type=style&index=0&id=0809f848&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0809f848"]])

export default __exports__